import { Button, Dialog, Stack, Typography } from "@mui/material";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { LoadingButton } from "../../../shared";

// Confirming generates the reprint, then the "Download or Print?" dialog hands it over
export const FtiReprintDialog = ({
  open,
  remarks,
  isGenerating,
  onConfirm,
  onClose,
}) => {
  return (
    <Dialog
      open={open}
      onClose={isGenerating ? undefined : onClose}
      PaperProps={{
        sx: { width: "460px", maxWidth: "calc(100% - 32px)", p: "16px" },
      }}
    >
      <Stack gap="12px">
        <Typography fontSize={16} fontWeight={600}>
          Re-Print FTI?/พิมพ์ใบกำกับภาษีเต็มรูปซ้ำหรือไม่?
        </Typography>
        <Typography fontSize={14} color="text.secondary">
          The same FTI details will be printed again/
          ระบบจะพิมพ์ข้อมูลใบกำกับภาษีเต็มรูปเดิมอีกครั้ง
        </Typography>
        <Stack
          direction="row"
          alignItems="center"
          gap="8px"
          sx={{ p: "8px 12px", borderRadius: "8px", bgcolor: "#FFF7E0" }}
        >
          <DescriptionOutlinedIcon sx={{ fontSize: 18 }} />
          <Typography fontSize={13}>Remarks: {remarks}</Typography>
        </Stack>
        <Stack direction="row" justifyContent="flex-end" gap="8px" mt="4px">
          <Button size="small" onClick={onClose} disabled={isGenerating}>
            Cancel/ยกเลิก
          </Button>
          <LoadingButton
            size="small"
            variant="contained"
            onClick={onConfirm}
            loading={isGenerating}
          >
            GENERATE/สร้าง
          </LoadingButton>
        </Stack>
      </Stack>
    </Dialog>
  );
};
